'use strict';

var chunkFVDNYYKY_js = require('./chunk-FVDNYYKY.js');
var chunkN7G236XZ_js = require('./chunk-N7G236XZ.js');
var chunkJHFKSNYO_js = require('./chunk-JHFKSNYO.js');

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function c(r){if(chunkN7G236XZ_js.a(r)||typeof r=="boolean"||typeof r=="function"||r instanceof Error)return !1;if(r==null||r==null||Array.isArray(r)&&r.length==0||chunkJHFKSNYO_js.a(r)&&Object.keys(r).length==0||typeof r=="string"&&r.trim()=="")return !0;try{if(chunkFVDNYYKY_js.a(r)&&r.size==0)return !0}catch(e){}return !1}

exports.a = c;
